import { render, staticRenderFns } from "./receiptRecord.vue?vue&type=template&id=1f82e704&scoped=true"
import script from "./receiptRecord.vue?vue&type=script&lang=js"
export * from "./receiptRecord.vue?vue&type=script&lang=js"
import style0 from "./receiptRecord.vue?vue&type=style&index=0&id=1f82e704&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82e704",
  null
  
)

export default component.exports